import { render } from "./Component.vue?vue&type=template&id=3f21f145"
import script from "./Component.vue?vue&type=script&lang=js"
export * from "./Component.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\epd-cnmp-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__